import request from 'api/request.js';
class api {
	constructor() {
		// 请求api
		this.http = `${request.http}`
		this.img_url = request.img_url
		this.apiUrl = {
			login: 'user/do_login', //登录
			index_data: 'index/apiHome', //获取轮播图
			user_time: 'user/api_updateactivetime', //更新用户活跃时间
			msg_detail: 'my/api_detail', //消息详情
			recharge_msg: 'ctrl/api_recharge', //获取充值信息
			recharge_check: 'ctrl/recharge_do_before', //充值检测接口
			pay_page: 'ctrl/api_recharge2', //支付页数据获取
			recharge: 'ctrl/recharge_do', //充值接口
			invite: 'my/api_invite', //邀请好友接口
			purchase_jilu: 'order/api_index', //抢单记录
			jilu_detailed: 'order/order_info', //抢单详情
			dingdan_accomplish: 'order/do_order', //订单完成接口

			order_data: 'rot_order/api_index', //抢单数据接口
			kefu: 'support/api_index', //客服
			user_info: 'my/api_index', //用户信息
			recharge_record: 'ctrl/api_recharge_admin', //充值记录
			deposit_admin: 'ctrl/api_deposit_admin', //提现记录
			headimg: 'my/api_headimg', //设置头像
			bind_bank: 'my/banklist', //银行列表查询
			revise_name: 'my/edit_username', //修改用户名称
			bind_trc: 'my/bind_trc20', //trc20地址修改接口
			my_bind_bank: 'my/bind_bank', //绑定银行卡接口
			set_pwd: 'ctrl/set_pwd', //修改密码接口
			edit_addresse: 'my/edit_address', //收货地址修改接口
			caiwu: 'my/api_caiwu', //交易明细查询接口
			team: 'ctrl/api_junior', //团队报表查询接口
			tixian_data: 'ctrl/api_deposit', //提现页数据接口


			do_deposit: 'ctrl/do_deposit', //申请提现接口
			submit_order: 'rot_order/submit_order', //申请提现接口
			regist_yanzheng: 'user/getData', //注册验证码
			regist: 'user/do_register', //注册

			// 获取login图片
			login_log: 'index/get_logo',
			roTgoodslist: 'shop/roTgoodslist2' ,//商品数据
			
			recharge_info: 'ctrl/recharge_info' ,
			recharge_list: 'ctrl/recharge_list' ,
		}
	}
	async recharge_list(para) {
		const res = await request.post(this.apiUrl.recharge_list, para)
		return res.data
	}
	// 推荐商品数据
	async roTgoodslist(para) {
		const res = await request.post(this.apiUrl.roTgoodslist, para)
		return res.data
	}
	// 微信登录
	async login(para) {
		const res = await request.post(this.apiUrl.login, para)
		return res.data
	}
	// 首页数据
	async index_data(para) {
		const res = await request.post(this.apiUrl.index_data, para)
		return res.data
	}
	// 更新用户活跃时间
	async user_time(para) {
		const res = await request.post(this.apiUrl.user_time, para)
		return res.data
	}
	// 消息详情
	async msg_detail(para) {
		const res = await request.post(this.apiUrl.msg_detail, para)
		return res.data
	}
	// 获取充值信息
	async recharge_msg(para) {
		const res = await request.post(this.apiUrl.recharge_msg, para)
		return res.data
	}
	// 充值检测接口
	async recharge_check(para) {
		const res = await request.post(this.apiUrl.recharge_check, para)
		return res.data
	}
	// 支付页数据
	async pay_page(para) {
		const res = await request.post(this.apiUrl.pay_page, para)
		return res.data
	}
	// 充值接口
	// async recharge(para) {
	// 	const res = await request.post(this.apiUrl.recharge, para)
	// 	return res.data
	// }
	async recharge(data) {
	    // 如果传入的 data 是 FormData，直接提交
	    if (data instanceof FormData) {
	        const res = await request.post(this.apiUrl.recharge, data);
	        return res.data;
	    }
}
	// async recharge() {
	// 	const res = await request.post(this.apiUrl.recharge)
	// 	return res.data
	// }
	async recharge_info(para) {
		const res = await request.post(this.apiUrl.recharge_info, para)
		return res.data
	}

	// 邀请好友
	async invite(para) {
		const res = await request.post(this.apiUrl.invite, para)
		return res.data
	}
	// 抢单记录
	async purchase_jilu(para) {
		const res = await request.post(this.apiUrl.purchase_jilu, para)
		return res.data
	}
	// 抢单详情
	async jilu_detailed(para) {
		const res = await request.post(this.apiUrl.jilu_detailed, para)
		return res.data
	}
	// 订单完成接口
	async dingdan_accomplish(para) {
		const res = await request.post(this.apiUrl.dingdan_accomplish, para)
		return res.data
	}
	// 枪弹也数据接口
	async order_data(para) {
		const res = await request.post(this.apiUrl.order_data, para)
		return res.data
	}
	// 客服
	async kefu(para) {
		const res = await request.post(this.apiUrl.kefu, para)
		return res.data
	}
	// 用户信息
	async user_info(para) {
		const res = await request.post(this.apiUrl.user_info, para)
		return res.data
	}
	// 置顶信息列表
	async recharge_record(para) {
		const res = await request.post(this.apiUrl.recharge_record, para)
		return res.data
	}
	// 提现列表
	async deposit_admin(para) {
		const res = await request.post(this.apiUrl.deposit_admin, para)
		return res.data
	}
	// 设置头像
	async headimg(para) {
		const res = await request.post(this.apiUrl.headimg, para)
		return res.data
	}
	// 银行卡列表
	async bind_bank() {
		const res = await request.post(this.apiUrl.bind_bank)
		return res.data
	}

	// 修改名称
	async revise_name(para) {
		const res = await request.post(this.apiUrl.revise_name, para)
		return res.data
	}
	// trc20地址修改接口
	async bind_trc(para) {
		const res = await request.post(this.apiUrl.bind_trc, para)
		return res.data
	}
	// 绑定银行卡接口
	async my_bind_bank(para) {
		const res = await request.post(this.apiUrl.my_bind_bank, para)
		return res.data
	}
	// 修改密码接口
	async set_pwd(para) {
		const res = await request.post(this.apiUrl.set_pwd, para)
		return res.data
	}
	// 收货地址修改接口
	async edit_addresse(para) {
		const res = await request.post(this.apiUrl.edit_addresse, para)
		return res.data
	}
	// 交易明细查询接口
	async caiwu(para) {
		const res = await request.post(this.apiUrl.caiwu, para)
		return res.data
	}
	// 团队报表查询接口
	async team(para) {
		const res = await request.post(this.apiUrl.team, para)
		return res.data
	}
	// 提现页面
	async tixian_data(para) {
		const res = await request.post(this.apiUrl.tixian_data, para)
		return res.data
	}

	// 申请提现接口
	async do_deposit(para) {
		const res = await request.post(this.apiUrl.do_deposit, para)
		return res.data
	}
	async submit_order(para) {
		const res = await request.post(this.apiUrl.submit_order, para)
		return res.data
	}

	async regist_yanzheng() {
		const res = await request.post(this.apiUrl.regist_yanzheng)
		return res.data
	}
	async regist(para) {
		const res = await request.post(this.apiUrl.regist, para)
		return res.data
	}
	async login_log(para) {
		const res = await request.post(this.apiUrl.login_log, para)
		return res.data
	}
}
export default new api()